
import { adlessCommand } from '.';
import { KPIsRequest, KPIsResponse, PoolAnalyticsRequest, PoolAnalyticsResponse, ServiceAnalyticsRequest, ServiceAnalyticsResponse } from './gen/analytics';

export default {
    pool: (req: PoolAnalyticsRequest) => adlessCommand<PoolAnalyticsResponse>("/v1/analytics/pool", req),
    kpi: (req: KPIsRequest) => adlessCommand<KPIsResponse>("/v1/analytics/kpi", req),
    service: (req: ServiceAnalyticsRequest) => adlessCommand<ServiceAnalyticsResponse>("/v1/analytics/service", req),
}